import { getBaseAssetUrl } from 'common/dist/utils/url';

import { alpha, lighten } from './color';

import * as api from '../api';

export function getPrevisitAsset(assetUrl: string) {
  return assetUrl ? `${getBaseAssetUrl()}/${encodeURIComponent(assetUrl)}` : '';
}

// simple padStart alternative for older browsers we use for numbers
export function padStartWithZero(input: string, length: number) {
  if (input.length >= length) return input;
  const zeroString = new Array(length - input.length).fill(0).join('');
  return zeroString + input;
}

export function applyTheme(theme: api.PracticeTheme.ThemeResponse) {
  /* TODO: https://app.asana.com/0/1204809327547775/1205800679430208/f */
  if (theme.organizationName === 'Banner Health') {
    document.documentElement.style.setProperty(
      '--font-family-headline',
      'Roboto Slab, serif',
    );
    document.documentElement.style.setProperty(
      '--font-family-title',
      'Open Sans, sans-serif',
    );
    document.documentElement.style.setProperty(
      '--font-family-paragraph',
      'Open Sans, sans-serif',
    );
    document.documentElement.style.setProperty('--line-height-title', '150%');
    document.documentElement.style.setProperty('--font-size-title', '1rem');
    document.documentElement.style.setProperty(
      '--font-weight-headline',
      'var(--weight-light)',
    );
    document.documentElement.style.setProperty(
      '--font-weight-title',
      'var(--weight-bold)',
    );
  }
  if (theme.primaryHexColor) {
    document.documentElement.style.setProperty(
      '--color-primary',
      theme.primaryHexColor,
    );

    document.documentElement.style.setProperty(
      '--color-primary-dark',
      lighten(theme.primaryHexColor, -10),
    );

    document.documentElement.style.setProperty(
      '--color-primary-darker',
      lighten(theme.primaryHexColor, -20),
    );

    document.documentElement.style.setProperty(
      '--color-primary-transparent',
      alpha(theme.primaryHexColor, 0.1),
    );

    document.documentElement.style.setProperty(
      '--color-primary-transparent-darker',
      alpha(theme.primaryHexColor, 0.2),
    );
  }
  if (theme.secondaryHexColor) {
    document.documentElement.style.setProperty(
      '--color-secondary',
      theme.secondaryHexColor,
    );
  }
}

export async function verifyRequest<T>(
  apiRequest: () => Promise<T>,
  onSuccess: (result: T) => Promise<void>,
  setOnCaptchaSuccess: (onCaptchaSuccess: (() => void) | null) => void,
) {
  const execute = async () => {
    try {
      const result = await apiRequest();
      setOnCaptchaSuccess(null);
      onSuccess(result);
    } catch (error) {
      console.log(error);
      if (error.status === 429) {
        setOnCaptchaSuccess(() => {
          execute();
        });
        return;
      }
      throw error;
    }
  };
  return execute();
}

export const generateGoogleMapsDirectionURL = ({
  address,
  city,
  state,
  zip,
}: {
  address: string;
  city: string;
  state: string;
  zip: string;
}) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${address} ${city} ${state} ${zip}`,
  )}`;
};
